import { render, staticRenderFns } from "./DocumentFieldDatetimeISOCompliant.vue?vue&type=template&id=35be441a&"
import script from "./DocumentFieldDatetimeISOCompliant.vue?vue&type=script&lang=js&"
export * from "./DocumentFieldDatetimeISOCompliant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports